// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: "AIzaSyDNcH-uMDjPaIwi0OMaJJN_e7oEaJjS7Es",
  authDomain: "pokemonteamplanner.firebaseapp.com",
  projectId: "pokemonteamplanner",
  storageBucket: "pokemonteamplanner.firebasestorage.app",
  messagingSenderId: "272225923786",
  appId: "1:272225923786:web:c1a888494a7e025135ba33"
};